import React from 'react';
import { Spin } from 'antd';

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'default', 
  className = '' 
}) => {
  return (
    <div className={`loading-spinner ${className}`}>
      <Spin 
        size={size}
        style={{
          color: '#55B6A6',
        }}
      />
    </div>
  );
};

export default LoadingSpinner;
